import { EditSharedReqPageComponent } from "./shared-req-restricted-edit-page.component";
export var EditSharedReqPageModule = angular
    .module('editSharedReqPage', [])
    .config(['$stateProvider',
    function ($stateProvider) {
        $stateProvider.state('missioncontrol.editSharedReq', {
            url: '/editSharedReq',
            component: EditSharedReqPageComponent.selector,
            data: {
                requireLogin: true
            },
            params: {
                jobId: null,
                corporateCompanyId: null,
                buId: null,
                jobState: null,
                jobName: null,
                jobType: null,
                requisitionInfo: null
            }
        });
    }
])
    .component(EditSharedReqPageComponent.selector, EditSharedReqPageComponent.component)
    .name;
//# sourceMappingURL=shared-req-restricted-edit-page.module.js.map